<div class="full-height-vendor">
  <div class="login-left">
    <div class="login-left-inner">
      <div class="login-logo">
        <a routerLink="/">
        <img src="/assets/img/new-logo.png"/>
        </a>
      </div>

      <ul>
        <li>
          <span>
            <img src="/assets/img/icon-24.png "/>
          </span>
        24/7 Online ordering access</li>
        <li><span>
          <img src="/assets/img/box-icon.png " />
        </span>Manage orders from multiple suppliers</li>
        <li><span>
          <img src="/assets/img/order-icon.png " />
        </span>Order history, tracking and invoices</li>
        <li><span>
          <img src="/assets/img/folder-icon.png " />
        </span>Live inventory and pricing</li>
      </ul>
    </div>
  </div>

  <div class="login-right">
    <div class="login-right-inner">
      <div class="login-right-scroll overflow-auto">
      <div class="login-box">

        <div>
          <h3 class="small-30 ml-lg-4">New to Clockwork</h3>
          <form class="signup-form" [formGroup]="form" (ngSubmit)="onRegister()">
            <p>
              Full Name
            </p>
            <input type="text" formControlName="name" class="form-control s-form-field" placeholder="Enter Your Full Name" />
            <span *ngIf="form.get('name').touched || form.get('name').dirty">
              <span class="error" *ngIf="form.get('name').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('name').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>
            <p>
              Email Address
            </p>
            <input formControlName="email" type="email" class="form-control s-form-field"
              placeholder="Enter Your Email Address" />
            <span *ngIf="form.get('email').touched || form.get('email').dirty">
              <span class="error" *ngIf="form.get('email').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('email').hasError('email')">Email is invalid</span>
            </span>
            <p>
              Password
            </p>
            <input type="password" formControlName="password" class="form-control s-form-field"
              placeholder="Enter Your Password" />
            <span *ngIf="form.get('password').touched || form.get('password').dirty">
              <span class="error" *ngIf="form.get('password').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('password').hasError('minlength')">Minimum 06 characters are allowed</span>
            </span>



            <p>
              Phone
            </p>
            <input type="text" formControlName="phone" class="form-control s-form-field" placeholder="Enter Your Phone" />
            <span *ngIf="form.get('phone').touched || form.get('phone').dirty">
              <span class="error" *ngIf="form.get('phone').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('phone').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>
            <p>
              Country
            </p>

            <select class="form-control custom-input" formControlName="country" (change)="onCountrySelect($event)">
              <option value="" disabled>Select Country</option>
              <option *ngFor="let country of countries" [selected]="country.id == 233" [value]="country.countryName">{{ country.countryName }}</option>
            </select>
            <span *ngIf="form.get('country').touched || form.get('country').dirty">
              <span class="error" *ngIf="form.get('country').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('country').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>
            <p>
              State
            </p>

            <select *ngIf="showUSstate" class="form-control custom-input" formControlName="state">
              <option value="" disabled>Select State</option>
              <option *ngFor="let state of usStates" [value]="state.name">{{ state.name }}</option>
            </select>
            <input type="text" *ngIf="!showUSstate" formControlName="state" class="form-control s-form-field" placeholder="Enter Your State" />
            <span *ngIf="form.get('state').touched || form.get('state').dirty">
              <span class="error" *ngIf="form.get('state').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('state').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>

            <p>
              City
            </p>
            <input type="text" formControlName="city" class="form-control s-form-field" placeholder="City" />
            <span *ngIf="form.get('city').touched || form.get('city').dirty">
              <span class="error" *ngIf="form.get('city').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('city').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>
            <p>
              Address
            </p>
            <input type="text" formControlName="address" class="form-control s-form-field" placeholder="Address" />
            <span *ngIf="form.get('address').touched || form.get('address').dirty">
              <span class="error" *ngIf="form.get('address').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('address').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>

            <p>
              Business Name
            </p>
            <input type="text" formControlName="business_name" class="form-control s-form-field" placeholder="Business Name" />
            <span *ngIf="form.get('business_name').touched || form.get('business_name').dirty">
              <span class="error" *ngIf="form.get('business_name').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('business_name').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>
            <p>
              Business Address
            </p>
            <input type="text" formControlName="business_address" class="form-control s-form-field" placeholder="Business Address" />
            <span *ngIf="form.get('business_address').touched || form.get('business_address').dirty">
              <span class="error" *ngIf="form.get('business_address').hasError('required')">This field is required</span>
              <span class="error" *ngIf="form.get('business_address').hasError('maxlength')">Maximum 50 characters are allowed</span>
            </span>





            <!-- <p class="small-text f-light">Already Register <a (click)="showSignIn()" class="cursor-pointer">Sign In</a> </p> -->
            <button type="submit" class="btn btn-01 mt-4 text-uppercase" [disabled]="registerProcessing">
              <app-preloader *ngIf="registerProcessing" [size]="'sm'"></app-preloader>
              <span *ngIf="!registerProcessing" class="cursor-pointer">Sign Up</span>
            </button>
          </form>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
